import React, { useEffect, useState, useRef } from "react";
import { PlusOutlined } from "@ant-design/icons";
import API_KEY from "../../../../api";
import {
  Row,
  Card,
  Col,
  Typography,
  Modal,
  Select,
  Button,
  message,
  Divider,
  Input,
  Form,
} from "antd";
import CategoryCard from "./CategoryCard";
import { Colors } from "../../../../theme";
import { gaEvent } from "analytics/analytics";
import * as GA from "../../../../constants/analytics";

const { Text, Title } = Typography;
const { Option } = Select;

const capitalize = (name) => {
  return name.charAt(0).toUpperCase() + name.slice(1);
};

export default function Categories({ isModalVisible, setIsModalVisible }) {
  const [categories, setCategories] = useState(null);
  //const [isModalVisible, setIsModalVisible] = useState(false);
  const [allCategories, setAllCategories] = useState(null);
  const [newCategory, setNewCategory] = useState(null);
  const [createCategory, setcreateCategory] = useState(null);
  const [manuCategories, setManuCategories] = useState(null);
  const [manufacturerId, setManufacturerId] = useState(null);
  const [errorText, setErrorText] = useState(null);
  const [dropdownState, setDropdownState] = useState(false);
  const [onLoadCatCreate, setOnLoadCatCreate] = useState(false);

  const selectRef = useRef();
  // api call for manufacturer's categories

  const fetchCategories = () => {
    const userId = localStorage.getItem("userId");
    var org = localStorage.getItem("org");
    const orgId = JSON.parse(org)?.id;

    API_KEY.URL.get(API_KEY.path.manufacturer, {
      params: {
        fields:
          "*,secondary_categories.secondary_category_id,secondary_categories.secondary_category_id.name,secondary_categories.secondary_category_id.id",
          deep:{"secondary_categories":{"_limit":-1}},
        },
    })
      .then((res) => {
        const data = res.data?.data[0];

        // const unique = (arr, encoder = JSON.stringify, decoder = JSON.parse) =>
        //   [...new Set(arr.map((item) => encoder(item)))].map((item) =>
        //     decoder(item)
        //   );

        const cats = data?.secondary_categories.map((item) => {
          return item.secondary_category_id;
        });

        // manufacturer's categories
        setManuCategories(
          data?.secondary_categories.map((item) => {
            return item.secondary_category_id?.name;
          })
        );

        if (localStorage.getItem("org")) {
          const org = JSON.parse(localStorage.getItem("org"));
          const orgId = org?.id;
          // sorting categories by alphabetical order for fantasy exports (orgid = 104)
          if (orgId === 104 || 228) {
            const sorted = cats.sort((a, b) =>
              a.name > b.name ? 1 : b.name > a.name ? -1 : 0
            );
            setCategories(sorted);
          } else {
            setCategories(cats);
          }
        }

        setManufacturerId(data?.id);
      })
      .catch((error) => console.log(error));
  };

  // api call for all categories
  const fetchAllCategories = () => {
    API_KEY.URL.get(API_KEY.path.secondaryCategory, {})
      .then((res) => {
        setAllCategories(res.data?.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchCategories();
    fetchAllCategories();
  }, []);
  const showModal = () => {
    setIsModalVisible((state) => !state);
  };

  const createSecondaryCategory = (name) => {
    var org = localStorage.getItem("org");
    const orgId = JSON.parse(org).id;
    const data = {
      primary_category: 4,
      name: name,
      manufacturer: orgId,
    };
    API_KEY.URL.post(API_KEY.path.secondaryCategory, data)
      .then((res) => {
        setAllCategories((state) => [
          ...state,
          { id: res?.data?.data?.id, name: res?.data?.data?.name },
        ]);
        message.success("Category added now select it.");
        setcreateCategory((state) => "");
        mapCategoryAndManufacture(res?.data?.data?.id);
        setOnLoadCatCreate(false);
        setIsModalVisible(false);
      })
      .catch((err) => console.log(err));
  };

  const mapCategoryAndManufacture = (id) => {
    const data = [
      {
        manufacturer_id: manufacturerId,
        secondary_category_id: id,
      },
    ];

    API_KEY.URL.post(`${API_KEY.path.manufacturer_secondary_category}`, data)
      .then((res) => {
        if (res.status === 200) {
          fetchCategories();
          setNewCategory((state) => null);
          setErrorText((state) => null);
        }
      })
      .catch((error) => console.log(error));
  };

  function isEmpty(val) {
    if (val != null) {
      return val.trim().length === 0;
    } else {
      return val === undefined || val === null || val.length <= 0
        ? true
        : false;
    }
  }
  const handleDone = () => {
    setOnLoadCatCreate(true);
    if (!createCategory || isEmpty(createCategory)) {
      setErrorText("Please select a category");
      message.warning("Please enter a category");
      setOnLoadCatCreate(false);
    } else {
      let element;
      let elementIndex = -1;
      if (manuCategories) {
        elementIndex = manuCategories?.findIndex(
          (element) => element?.toLowerCase() === createCategory?.toLowerCase()
        );
        if (elementIndex !== -1) element = manuCategories[elementIndex];
      }
      if (elementIndex === -1) {
        createSecondaryCategory(capitalize(createCategory));
      } else {
        message.warning("Category already exists");
        setOnLoadCatCreate(false);
        setNewCategory((state) => null);
        setErrorText((state) => null);
      }
    }
  };
  // add new category
  const handleOk = () => {
    //wip
    onClickAddNewCategoryButton();

    const el = allCategories.find((e) => e.id === newCategory);

    if (!newCategory) {
      setErrorText("Please select a category");
    } else {
      setIsModalVisible(false);
    }

    let element;
    let elementIndex = -1;
    if (manuCategories) {
      elementIndex = manuCategories?.findIndex(
        (element) => element?.toLowerCase() === el.name?.toLowerCase()
      );
      if (elementIndex !== -1) element = manuCategories[elementIndex];
    }
    if (elementIndex === -1) {
      createSecondaryCategory(capitalize(el?.name));
    } else {
      message.warning("Category already exists");
      setNewCategory((state) => null);
      setErrorText((state) => null);
    }
  };

  const handleCancel = () => {
    setDropdownState(false);
    setcreateCategory((state) => "");
    setTimeout(function () {
      setIsModalVisible(false);
    }, 200);

    setNewCategory((state) => null);
    setErrorText((state) => null);
  };
  const handleChange = (value) => {
    setNewCategory(value);
    setDropdownState(false);
    selectRef?.current?.blur();
  };
  const onNewCategoryInputChange = (event) => {
    setcreateCategory(event.target.value);
  };
  const onClickAddNewCategoryButton = () => {
    if (!createCategory) {
      message.warning("Please enter a valid category name");
    } else {
      setAllCategories((state) => [
        ...state,
        { id: `${createCategory}_id`, name: createCategory },
      ]);
      // message.success("Category added now select it.");
      setNewCategory(`${createCategory}_id`);
      selectRef?.current?.blur();
      setDropdownState(false);

      console.log("allCategories", allCategories);
      // const data = {
      //   status: "published",
      //   primary_category: 4,
      //   name: createCategory,
      // };

      // API_KEY.URL.post(API_KEY.path.secondaryCategory, data)
      //   .then((res) => {
      //     // setAllCategories([
      //     //   ...allCategories,
      //     //   { id: res?.data?.data?.id, name: res?.data?.data?.name },
      //     // ]);

      //   })
      //   .catch((err) => console.log(err));

      // setErrorText((state) => null);
    }
  };

  const onFinish = (values) => {
    console.log(values);
  };

  return (
    //<div>
    //   <Modal
    //     centered
    //     footer={null}
    //      visible={isModalVisible}
    //     onOk={handleOk}
    //     onCancel={handleCancel}
    //   >
    //     <Row>
    //       <Title level={4} style={{ fontFamily: "GilRoy" }}>
    //         Add New Category{isModalVisible}
    //       </Title>
    //     </Row>
    //     {errorText && (
    //       <Row style={{ marginBottom: "1rem" }}>
    //         <Text type="danger">{errorText}</Text>
    //       </Row>
    //     )}

    //     <Row justify="space-between">
    //       <Select
    //         value={newCategory}
    //         showSearch
    //         style={{ width: "70%" }}
    //         placeholder="Name of the category"
    //         optionFilterProp="children"
    //         open={dropdownState}
    //         onFocus={() => {
    //           setDropdownState(true);
    //           gaEvent(
    //             GA.EVENT.HOVER,
    //             GA.CATEGORY.MASTER_CATALOGUE,
    //             GA.DESCRIPTION.ADD_NEW_CATEGORY_SELECT_NAME
    //           );
    //         }}
    //         onClick={() => {
    //           gaEvent(
    //             GA.EVENT.CLICK,
    //             GA.CATEGORY.MASTER_CATALOGUE,
    //             GA.DESCRIPTION.ADD_NEW_CATEGORY_SELECT_NAME
    //           );
    //         }}
    //         ref={selectRef}
    //         // filterOption={(input, option) => {
    //         //   console.log(input,'input')
    //         //   return (

    //         //     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    //         //   );
    //         // }}
    //         // filterSort={(optionA, optionB) =>
    //         //   optionA.children
    //         //     .toLowerCase()
    //         //     .localeCompare(optionB.children.toLowerCase())
    //         // }
    //         onChange={handleChange}
    //         dropdownRender={(menu) => (
    //           <div>
    //             {menu}
    //             <Divider style={{ margin: "4px 0" }} />
    //             <div
    //               style={{ display: "flex", flexWrap: "nowrap", padding: 8 }}
    //             >
    //               <Input
    //                 style={{ flex: "auto" }}
    //                 value={createCategory}
    //                 onChange={onNewCategoryInputChange}
    //                 onClick={() => {
    //                   gaEvent(
    //                     GA.EVENT.CLICK,
    //                     GA.CATEGORY.MASTER_CATALOGUE,
    //                     GA.DESCRIPTION.ADD_NEW_CATEGORY_INPUT_NAME
    //                   );
    //                 }}
    //               />
    //               <span
    //                 style={{
    //                   flex: "none",
    //                   padding: "8px",
    //                   display: "block",
    //                   cursor: "pointer",
    //                 }}
    //                 onClick={() => {
    //                   onClickAddNewCategoryButton();
    //                   gaEvent(
    //                     GA.EVENT.CLICK,
    //                     GA.CATEGORY.MASTER_CATALOGUE,
    //                     GA.DESCRIPTION.ADD_NEW_CATEGORY_ADD_NEW_ITEM
    //                   );
    //                 }}
    //               >
    //                 <PlusOutlined /> Add item
    //               </span>
    //             </div>
    //           </div>
    //         )}
    //       >
    //         {allCategories &&
    //           allCategories.map((item) => (
    //             <Option key={item?.id} value={item?.id}>
    //               {item?.name}
    //             </Option>
    //           ))}
    //       </Select>
    //       <Button
    //         style={{ width: "25%" }}
    //         onClick={() => {
    //           handleOk();
    //           gaEvent(
    //             GA.EVENT.CLICK,
    //             GA.CATEGORY.MASTER_CATALOGUE,
    //             GA.DESCRIPTION.ADD_NEW_CATEGORY_DONE_BUTTON
    //           );
    //         }}
    //         type="primary"
    //       >
    //         Done
    //       </Button>
    //     </Row>
    //   </Modal>

    <div>
      <Modal
        centered
        footer={null}
        visible={isModalVisible}
        onOk={handleDone}
        onCancel={handleCancel}
        width={"42em"}
        destroyOnClose={true}
        closable={false}
        maskClosable={false}
      >
        <Form onFinish={onFinish}>
          <Col>
            <Row>
              <Text
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "#040E0C",
                  marginBottom: "1.2em",
                }}
              >
                Add new category
              </Text>
            </Row>
            <Row>
              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: "normal",
                  color: "#1D2624",
                }}
              >
                Name
              </Text>
            </Row>
            <Row>
              <Form.Item
                name={["user", "name"]}
                rules={[
                  {
                    required: true,
                    message: "Please enter a category ",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <Input
                  type="textarea"
                  style={{
                    width: "100%",
                    height: "3em",
                    borderRadius: "4px",
                    border: "1px solid #CDCFCE",
                    marginTop: "0.5em",
                    marginBottom: "0.5em",
                    padding: "0.8em",
                  }}
                  placeholder="Enter"
                  onChange={onNewCategoryInputChange}
                />
              </Form.Item>
            </Row>
            <Row style={{ marginTop: "1em" }}>
              <Button
                style={{
                  height: "3rem",
                  fontSize: "18px",

                  width: "10em",
                  float: "left",
                  marginRight: "10em",
                }}
                onClick={handleCancel}
              >
                Cancel
              </Button>

              <Button
                size="large"
                style={{
                  height: "3rem",
                  fontSize: "18px",
                  background: "#363E3D",
                  color: "white",
                  float: "right",
                  width: "10em",
                }}
                // onClick={onClickAddNewCategoryButton}
                onClick={handleDone}
                htmlType="submit"
                loading={onLoadCatCreate}
              >
                Done
              </Button>
            </Row>
          </Col>
        </Form>
      </Modal>

      {/* /* <div className="site-card-wrapper"> */}
      <Row>
        {categories &&
          categories.map((item, index) => (
            <CategoryCard key={index} item={item} />
          ))}

        <Col
          xs={24}
          sm={24}
          md={12}
          lg={6}
          xl={6}
          style={{ marginTop: "1rem" }}
        >
          <Card
            onClick={() => {
              showModal();
              gaEvent(
                GA.EVENT.CLICK,
                GA.CATEGORY.MASTER_CATALOGUE,
                GA.DESCRIPTION.ADD_NEW_CATEGORY
              );
            }}
            bordered
            className="category-card"
            style={{
              // height: "11rem",
              minHeight: "100%",
              // width: "18rem",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#F0F8F6",
            }}
          >
            <Row>
              <Text style={{ color: Colors.primaryColor }}>
                + Add a new category
              </Text>
            </Row>
          </Card>
        </Col>
      </Row>
      {/* </div> */}
    </div>
  );
}
